import { render } from "./LanguageSupport.vue?vue&type=template&id=911162f2"
import script from "./LanguageSupport.vue?vue&type=script&lang=js"
export * from "./LanguageSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__